import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { CookieAcceptService } from './core/cookies/cookie-accept.service';
import { LoadingService } from './core/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnDestroy {
  title = 'frontend';

  loading$: Observable<boolean>;

  private _subs: Subscription[] = [];

  constructor(
    public loadingService: LoadingService,
    private el: ElementRef,
    private translate: TranslateService,
    private cookieService: CookieAcceptService,
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    for (const sub of this._subs) {
      sub.unsubscribe();
    }
  }
}
